var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKurgebuehr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#304785;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-844 -1528)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5,2A2.6,2.6,0,0,0,3.05,3.123,5.624,5.624,0,0,0,2,6.5,5.624,5.624,0,0,0,3.05,9.877,2.6,2.6,0,0,0,5,11,2.6,2.6,0,0,0,6.95,9.877,5.624,5.624,0,0,0,8,6.5,5.624,5.624,0,0,0,6.95,3.123,2.6,2.6,0,0,0,5,2M5,0c2.761,0,5,2.91,5,6.5S7.761,13,5,13,0,10.09,0,6.5,2.239,0,5,0Z",
    transform: "translate(850 1532)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(844 1528)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1,3.75A1.75,1.75,0,0,1,2.75,2h21A1.75,1.75,0,0,1,25.5,3.75Zm12.25,14a3.5,3.5,0,1,0-3.5-3.5A3.5,3.5,0,0,0,13.25,17.75Z",
    transform: "translate(0.75 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,5.75A1.75,1.75,0,0,1,1.75,4h24.5A1.75,1.75,0,0,1,28,5.75v14a1.75,1.75,0,0,1-1.75,1.75H1.75A1.75,1.75,0,0,1,0,19.75Zm5.25,0a3.5,3.5,0,0,1-3.5,3.5v7a3.5,3.5,0,0,1,3.5,3.5h17.5a3.5,3.5,0,0,1,3.5-3.5v-7a3.5,3.5,0,0,1-3.5-3.5Z",
    transform: "translate(0 -0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKurgebuehr);
export default __webpack_public_path__ + "static/media/kurgebuehr.52466ca9f03faea7fe57899ceecd085f.svg";
export { ForwardRef as ReactComponent };